import { useContext } from 'react'

import HybridTeaserContext from '@contexts/hybridTeaser'

const useIsHybridTeaser = (): boolean => !!useContext(HybridTeaserContext)

export default useIsHybridTeaser
